export const sendStaffAppMetaData = (payload) =>
  !!window.ReactNativeWebView &&
  window.ReactNativeWebView.postMessage(
    JSON.stringify({ payload, type: "STAFF_APP_META_DATA" })
  );

export function staffAppEventTriggers(props, state, setState) {
  const { config } = props;
  const staffAppMetaData = config.tab_default_meta_data;

  // set initial
  sendStaffAppMetaData({
    ...staffAppMetaData.find((node) => node.detail == "general"),
    tabsData: props.config.resident_tabs,
  });

  document.addEventListener("edit", (e) => props.toggleAction());
  document.addEventListener("save", (e) => props.saveProfile());

  document.addEventListener("set-tab", (e) => {
    setState({ tabKey: e.detail });
    const data = staffAppMetaData.find((tab) => tab.detail == e.detail);
    sendStaffAppMetaData({ ...data, tabsData: props.config.resident_tabs });
  });

  function createListenersFor(tabName, ResourceName, modalName, lbbLabel) {
    document.addEventListener(`close${ResourceName}Form`, (e) => {
      sendStaffAppMetaData({
        ...staffAppMetaData.find((tab) => tab.detail == tabName),
        selectedTab: tabName,
        tabsData: props.config.resident_tabs,
      });
      props.closeModal(modalName);
    });

    document.addEventListener(`showNew${ResourceName}Form`, (e) => {
      props.newResource(modalName);
      const data = staffAppMetaData.find((tab) => tab.detail == tabName);
      sendStaffAppMetaData(data.modal);
    });
  }

  createListenersFor("contacts", "Contact", "contact", "Contacts");
  createListenersFor(
    "family_members",
    "FamilyMember",
    "familyMember",
    "Family Members"
  );
  createListenersFor("doctors", "Therapist", "therapist", "Doctors");
  createListenersFor(
    "employment_history",
    "Occupation",
    "occupation",
    "Employment History"
  );
  createListenersFor(
    "education_history",
    "Education",
    "education",
    "Education History"
  );
  createListenersFor("insurances", "Insurance", "insurance", "Insurances");
  createListenersFor("probations", "Probation", "probation", "Probations");
  createListenersFor("meds", "Medication", "medication", "Medications");
  createListenersFor("past_occupancies", "PastOccupancy", "pastOccupancy", "Past Occupancies");
  createListenersFor("current_occupancies", "CurrentOccupancy", "currentOccupancy", "Current Occupancies");
  createListenersFor(
    "sober_living_history",
    "SoberLiving",
    "soberLiving",
    "Sober Living History"
  );
  createListenersFor(
    "living_arrangement_history",
    "LivingArrangementHistory",
    "livingArrangementHistory",
    "Living Arrangement History"
  );
  createListenersFor(
    "treatment_center_history",
    "TreatmentCenter",
    "treatmentCenter",
    "Treatment Center History"
  );
  createListenersFor("vaccines", "Vaccine", "vaccine", "Vaccines");
  createListenersFor("tests", "Test", "test", "Tests");
  createListenersFor(
    "counseling_history",
    "CounselingHistory",
    "counselingHistory",
    "Counseling History"
  );
  createListenersFor(
    "child_welfare_history",
    "ChildWelfareHistory",
    "childWelfareHistory",
    "Child Welfare History"
  );
}
